import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-menu-item',
  templateUrl: './side-menu-item.component.html',
  styleUrls: ['./side-menu-item.component.css']
})
export class SideMenuItemComponent implements OnInit {
  @Input() title = 'Previsão de Venda';
  @Input() selected = false;
  @Input() routerLink: string;
  @Input() icon: any;

  constructor() { }

  ngOnInit() {
  }

}
